import {
  Badge,
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardBody,
} from '@vnetwork/ui/primitives';
import { useAuth } from '@/auth/AuthProvider';
import { tokenStorage } from '@/lib/token-storage';
import styles from './Information.module.css';

/**
 * Read-only identity card. Mirrors the legacy ManageProfile — it does not edit
 * anything; the data comes from the authenticated session (`useAuth`).
 */
export function ProfileCard() {
  const { user } = useAuth();
  const method = tokenStorage.authMethod;

  const name = user?.name?.trim() || user?.email || 'Account';
  const initial = (user?.name ?? user?.email ?? '?').charAt(0).toUpperCase();
  const roles = user?.roles?.filter(Boolean) ?? [];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Profile</CardTitle>
        <CardDescription>Your account identity and session details.</CardDescription>
      </CardHeader>
      <CardBody>
        <div className={styles.identity}>
        <div className={styles.avatar} aria-hidden>
          {initial}
        </div>
        <div className={styles.identityText}>
          <span className={styles.identityName}>{name}</span>
          <span className={styles.identityEmail}>{user?.email}</span>
        </div>
      </div>

      <dl className={styles.defs}>
        <dt className={styles.defLabel}>Email</dt>
        <dd className={styles.defValue}>{user?.email || '—'}</dd>

        <dt className={styles.defLabel}>User ID</dt>
        <dd className={styles.defValue}>{user?.uuid || '—'}</dd>

        <dt className={styles.defLabel}>Sign-in method</dt>
        <dd className={styles.defValue}>
          <Badge tone={method === 'local' ? 'neutral' : 'primary'} appearance="subtle" size="sm">
            {method === 'sso' ? 'SSO' : method === 'google' ? 'Google' : 'Email & password'}
          </Badge>
        </dd>

        {roles.length > 0 && (
          <>
            <dt className={styles.defLabel}>Roles</dt>
            <dd className={styles.defValue}>
              <span style={{ display: 'inline-flex', flexWrap: 'wrap', gap: 6 }}>
                {roles.map((r) => (
                  <Badge key={r} tone="neutral" appearance="subtle" size="sm">
                    {r}
                  </Badge>
                ))}
              </span>
            </dd>
          </>
        )}
        </dl>
      </CardBody>
    </Card>
  );
}
